const Here = window.H;

const GeofencingPlugin = () => {

    let circlesGroup;

    let editingGeofencingArea, areaOutline, zoom;

    let listeningMapClicks = true;

    const setData = (data) => {
        editingGeofencingArea.setData(data)
    }
    
    const toggleMapListener = () => {
        listeningMapClicks = !listeningMapClicks;
    }

    const mutateCircles = {
        remove(circleObj) {
            circlesGroup.removeObject(circleObj);
        }
    }

    // Turn on and off the outline of a circle
    const setOutline = (toggle, elem) => {
        switch (toggle) {
            case 'on':
                {
                    let currentStyle = elem.getStyle();
                    
                    let newStyle = currentStyle.getCopy({
                        lineWidth: 4
                    });
                    
                    elem.setStyle(newStyle)
                }
                break;

            case 'off': {
                let currentStyle = elem.getStyle(),
                newStyle = currentStyle.getCopy({
                lineWidth: 0
                });

                elem.setStyle(newStyle);
            }
            break;
            
            default: return;
            }
    }

    // Change style and attach data to created/updated shape on map and clean up plugin state
    const submitGeofencingArea = (areaData) => {
        areaOutline.getGeometry().pushPoint(areaOutline.getGeometry().extractPoint(0));
        setOutline('off', areaOutline)
        setData(areaData)
        editingGeofencingArea = null;
    }

    const initPlugin = ({ 
            setCenter,
            initialData, 
            onSelectGeofencingArea, 
            setRadius, 
            setData, 
            setEditMode, 
            setCreatingNewArea,
        }) => map => {

            // Aggiorna lo zoom nello stato di Dashboard
            map.addEventListener('mapviewchangeend', () => {
                let newZoom = map.getZoom();

                zoom = newZoom;
            })

        const _createCircle = (center, radius) => {
            // Draw shapes
            const circle = new Here.map.Circle(
                center, 
                radius, 
                {
                    style: { fillColor: "rgba(171,36,48, 0.4)", lineWidth: 0 }
                }
                ),
                circleOutline = new Here.map.Polyline(
                    circle.getGeometry().getExterior(),
                    {
                        style: { fillColor: "rgba(171,36,48, 0.4)", lineWidth: 4, strokeColor: "red"}
                    }
                    );
                    
                    const circleShape = new Here.map.Group({
                        volatility: true,
                        objects: [circle, circleOutline]
                    })
                    
                    circle.draggable = true;
                    circleOutline.draggable = true;

                // Set currently selected area
                editingGeofencingArea = circleShape;
                
                areaOutline = circleOutline;

                onSelectGeofencingArea(circleShape)
                
                //  Set up style changes
                circleOutline.getGeometry().pushPoint(circleOutline.getGeometry().extractPoint(0));
                
                // Outline the circle on hover
                circleShape.addEventListener('pointerenter', evt => {
                    if(editingGeofencingArea === circleShape) return;
                    if(listeningMapClicks) {
                        setOutline('on', circleOutline);
                        document.body.style.cursor = 'pointer';
                    }
                }, true);
                
                circleShape.addEventListener('pointerleave', function(evt) {
                    if (editingGeofencingArea === circleShape) return;
                    setOutline('off', circleOutline);
                    document.body.style.cursor = 'default';
                }, true);

                // Resize Circle on drag (after having selected a geofencing area to edit)
                circleShape.addEventListener('drag', function(evt) {
                    if(editingGeofencingArea === circleShape) {

                        let pointer = evt.currentPointer,
                        distanceFromCenterInMeters = circle.getCenter().distance(map.screenToGeo(pointer.viewportX, pointer.viewportY));
                        
                        // if resizing is allowed, set the circle's radius
                        if (evt.target instanceof Here.map.Polyline) {
                            circle.setRadius(distanceFromCenterInMeters);
                            setRadius(distanceFromCenterInMeters);
                            // use circle's updated geometry for outline polyline
                            let outlineLinestring = circle.getGeometry().getExterior();
                            
                            // extract first point of the outline LineString and push it to the end, so the outline has a closed geometry
                            outlineLinestring.pushPoint(outlineLinestring.extractPoint(0));
                            circleOutline.setGeometry(outlineLinestring);
                            
                            // prevent event from bubling, so map doesn't receive this event and doesn't pan
                            evt.stopPropagation();
                        }
                        document.body.style.cursor = 'nesw-resize';
                    }
                }, true);

                // Resizing pointer on outline hover whilst editing geofencing area
                circleOutline.addEventListener('pointerenter', evt => {
                    if (editingGeofencingArea) {
                        document.body.style.cursor = 'nesw-resize';
                    }
                })

                circleOutline.addEventListener('pointerleave', evt => {
                    if (editingGeofencingArea) {
                        document.body.style.cursor = 'default';
                    }
                })

                // Style outline when geofencing area gets selected
                circleShape.addEventListener('tap', evt => {
                    if (listeningMapClicks) {
                            editingGeofencingArea = circleShape;
                            
                            const areaData = editingGeofencingArea.getData();
                            setData(areaData);
                            center = circle.getCenter()
                            setCenter(center);
                            onSelectGeofencingArea(circleShape);
                            setEditMode(true)
                            let currentStyle = circleOutline.getStyle();
                            
                            let newStyle = currentStyle.getCopy({
                                lineWidth: 4
                            });
                            
                            circleOutline.setStyle(newStyle)
                            
                            document.body.style.cursor = 'default';
                            evt.stopPropagation();
                            toggleMapListener();
                        }
                        })

                // Pass the shape info to component state and turn off map click listener
                // onSelectGeofencingArea(circleShape)

                return circleShape;
        }

            const _startListener = cb => {
                const handleEvent = evt => {
                        const coord = map.screenToGeo(evt.currentPointer.viewportX, evt.currentPointer.viewportY);
                        
                        const {lat, lng} = coord;
                        setCenter({ lat, lng });
                        setCreatingNewArea(true);

                        return cb(null, { lat, lng });
                }
                
                    map.addEventListener('tap', evt => {
                        if (listeningMapClicks) {
                            handleEvent(evt)
                            toggleMapListener()
                        } else return
                    });

                return {
                    unsubscribe: () => map.removeEventListener('tap', handleEvent)
                }
            }

            const _createCirclesGroup = (circle) => {
                circlesGroup = new Here.map.Group({
                    volatility: true,
                    objects: [circle]
                })

                map.addObject(circlesGroup)
            }

            const _createCirclesFromInitialData = initialData => {
                initialData.map(geofencingArea => {
                    const center = {
                        lat: geofencingArea.lat, 
                        lng: geofencingArea.lng,
                    }
                    
                    const radius = geofencingArea.radius
                        let circle = _createCircle(center, radius);
                        circle.setData(geofencingArea);

                    setOutline('off', areaOutline);
                    editingGeofencingArea = null;
                    onSelectGeofencingArea(null);

                    if (!circlesGroup) {
                        return _createCirclesGroup(circle);
                    } else {
                        return circlesGroup.addObject(circle);
                    }
                })
            }

            _startListener((error, { lat, lng }) => {
                const center = {
                    lat: lat,
                    lng: lng,
                };
                
                const radius = 40 * Math.abs((40007000.863 / Math.pow(2, (zoom + 8))));
                
                // Passa il raggio di default allo stato di DashboardPage

                setRadius(radius)
                
                const circle = _createCircle(center, radius);
                
                if (!circlesGroup) {
                    _createCirclesGroup(circle);
                } else {
                    circlesGroup.addObject(circle);
                }
            });

            if (initialData && initialData.length > 0) {
                circlesGroup = null;
                _createCirclesFromInitialData(initialData);
            }
    }
    return {initPlugin, submitGeofencingArea, toggleMapListener, mutateCircles, setData}
};

export default GeofencingPlugin